import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AccountUploadsType } from "@/services/type";

export interface ApplicationFormState {
  coverLetter: string;
  hasEditedCoverLetter?: boolean;
  attachments: AccountUploadsType[];
  selectedFileIds: number[];
  allowProfileAccess: boolean;
}

export const initialApplicationFormState: ApplicationFormState = {
  coverLetter: "",
  attachments: [],
  selectedFileIds: [],
  allowProfileAccess: false,
};

interface ApplicationFormStore {
  form: ApplicationFormState;
  setForm: (form: ApplicationFormState) => void;
  updateForm: (updates: Partial<ApplicationFormState>) => void;
  resetForm: () => void;
}

export const useApplicationFormStore = create<ApplicationFormStore>()(
  persist(
    (set) => ({
      form: initialApplicationFormState,
      setForm: (form) => set({ form }),
      updateForm: (updates) =>
        set((state) => ({
          form: { ...state.form, ...updates },
        })),
      resetForm: () => set({ form: initialApplicationFormState }),
    }),
    {
      name: "application-form-store",
    }
  )
);
